import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

export default function Navbar() {
  const [clicked, clicker] = useState(false);
  const isLoggedIn = getCookie('COOKIE_LOGGED_IN') === 'true';

  function handleClick() {
    clicker((prev) => !prev);
  }

  function handleLogout() {
    document.cookie = 'COOKIE_LOGGED_IN=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    window.location.href = '/';
  }

  return (
    <div className="header" id="header">
      <Link to="/">
        <img
          src={process.env.PUBLIC_URL + '/images/aidafyLogo.png'}
          alt="Wibson"
          className="logo-word"
        ></img>
      </Link>
      <div className={clicked ? 'navbar drop' : 'navbar colapse'}>
        <Link className="global-link nav-element" to="/">
          Home
        </Link>
        <Link className="global-link nav-element" to="/start">
          Contact Us
        </Link>
        <Link className="global-link nav-element" to="/privacy">
          Privacy Policy
        </Link>
        {isLoggedIn ? (
          <button className="nav-auth-btn" onClick={handleLogout}>Logout</button>
        ) : (
          <Link className="nav-auth-btn" to="/login">Login</Link>
        )}
      </div>
      <i onClick={handleClick} className="fas fa-bars nav-bar-icon"></i>
    </div>
  );
}
